"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumBusRange = void 0;
class AltiumBusRange {
    static { this.MAX_WIDTH = 4096; }
    static parse(text) {
        const match = /^(.*?)\[\s*(\d+)\s*\.\.\s*(\d+)\s*\]$/.exec(text.trim());
        if (!match) {
            return undefined;
        }
        const prefix = match[1];
        const from = parseInt(match[2], 10);
        const to = parseInt(match[3], 10);
        if (!Number.isSafeInteger(from) || !Number.isSafeInteger(to) || Math.abs(to - from) >= AltiumBusRange.MAX_WIDTH) {
            return undefined;
        }
        const step = from <= to ? 1 : -1;
        const members = [];
        for (let i = from; step > 0 ? i <= to : i >= to; i += step) {
            members.push(`${prefix}${i}`);
        }
        return { declaration: text.trim(), prefix, members };
    }
}
exports.AltiumBusRange = AltiumBusRange;
//# sourceMappingURL=AltiumBusRange.js.map